<section class="section py-6">
  <div class="columns">
    <div class="column header-title-page">
      <h2 class="title-header">Materias Primas</h2>
      <button class="button is-primary" (click)="openModal()">Nueva materia prima</button>
    </div>
  </div>
  <div class="columns">
    <div class="column is-6">
      <div class="field">
        <label class="label">Buscar</label>
        <p class="control has-icons-left">
          <input class="search-bar input" type="text" placeholder="Buscar..." [(ngModel)]="filters.search.value" (keyup.enter)="onFilter()">
          <span class="icon is-left">
            <fa-icon class="icon-search" [icon]="faMagnifyingGlass"></fa-icon>
          </span>
        </p>
      </div>
    </div>
  </div>
</section>
<section class="section py-1">
  <div class="columns has-background-white">
    <div class="column">
      <div class="columns">
        <div class="column p-5">
          <div class="table-products" *ngIf="products">
            <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="productsFiltered" 
              (onSelectRow)="openModal($event)" (onDeleteItem)="delete($event)"></app-generic-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="modal" [ngClass]="{'is-active': isModalActive }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <form [formGroup]="form" (ngSubmit)="onSave()">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ isCreating ? 'Nueva Materia Prima' : 'Materia Prima: ' + form.value.id }}
        </p>
        <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Mixtion</label>
              <div class="control">
                <input class="input" type="text" formControlName="mixtion" placeholder="Mixtion">
              </div>
            </div>
            <div class="field">
              <label class="label">Zona</label>
              <div class="control">
                <input class="input" type="text" formControlName="zona" placeholder="Zona">
              </div>
            </div>
            <div class="field">
              <label class="label">Invierno NH</label>
              <div class="control">
                <input class="input" type="number" formControlName="inviernoNH" placeholder="Invierno NH">
              </div>
            </div>
            <div class="field">
              <label class="label">Verano NH</label>
              <div class="control">
                <input class="input" type="number" formControlName="veranoNH" placeholder="Verano NH">
              </div>
            </div>
            <div class="field">
              <label class="label">Invierno H</label>
              <div class="control">
                <input class="input" type="text" formControlName="inviernoH" placeholder="Invierno H">
              </div>
            </div>
            <div class="field">
              <label class="label">Verano H</label>
              <div class="control">
                <input class="input" type="text" formControlName="veranoH" placeholder="Verano H">
              </div>
            </div>
            <div class="field">
              <label class="label">Super</label>
              <div class="control">
                <input class="input" type="text" formControlName="super" placeholder="Super">
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-space-between">
        <button type="button" class="button" (click)="closeModal()">Cancelar</button>
        <button type="submit" class="button is-primary" [disabled]="!form.valid">
          <fa-icon *ngIf="isLoading" [icon]="faSpinner"></fa-icon>
          <span *ngIf="!isLoading">Guardar</span>
        </button>
      </footer>
    </form>
  </div>
</div>
